<!-- main app container -->
<div class="jumbotron">

    <!-- <alert></alert> -->
    <router-outlet></router-outlet>
    <!-- <footer class="site-footer">
    <div class="">© Copyrights {{curYear}}.Groundbuddy.All Rights Reserved.<span style="float: right;">Designed & Developed by <a href="https://chipsyservices.com" target="_blank">Chipsy</a></span></div>

  </footer>     -->
</div>